export function isFlagValueOn(value: string | undefined): boolean {
  return String(value).trim().toLowerCase() === 'true'
}
